module.exports = __webpack_public_path__ + "static/media/munch15.9b8ef3b2.wav";